import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';
import styled from 'styled-components';

import BreadCrumbArrow from '@/components/atom/icon/arrow/BreadCrumbArrow';
import { zIndex } from '@/constants/zIndex';
import { Tablet } from '@/styles/layout';
import { BreadCrumb } from '@/types/common';
import { getPageName, logger } from '@/utils/logger';

interface Props {
  visible: boolean;
  breadCrumbs: BreadCrumb[];
}

const CustomBreadCrumbs = ({ visible, breadCrumbs }: Props) => {
  const router = useRouter();
  const onClickBreadCrumb = (name: string) => {
    logger({
      pageName: getPageName(router),
      eventName: `breadcrumb_${name}_click`,
    });
  };

  const breadCrumbsWithHome = [
    {
      label: '홈',
      url: '/',
      logName: 'home',
    },
    ...breadCrumbs,
  ];

  return (
    <Wrapper visible={visible} id='breadcrumbs'>
      {breadCrumbsWithHome.map((item, index) => (
        <Path role='button' key={item.label} onClick={() => onClickBreadCrumb(item.logName)}>
          <Link href={item.url}>
            <a>
              <p>{item.label}</p>
            </a>
          </Link>
          {index !== breadCrumbsWithHome.length - 1 && <BreadCrumbArrow />}
        </Path>
      ))}
    </Wrapper>
  );
};

export default CustomBreadCrumbs;

const Wrapper = styled.div<{ visible: boolean }>`
  ${({ theme }) => theme.typography.UI13M};
  color: ${({ theme }) => theme.color.gray400};
  visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
  position: ${({ visible }) => (visible ? 'static' : 'absolute')};
  display: flex;

  @media screen and (max-width: ${Tablet}) {
    ${({ theme }) => theme.typography.UI14R};
  }
`;

const Path = styled.div`
  display: flex;
  align-items: center;
  svg {
    margin: 0 2px;
  }
  p:hover {
    text-decoration: underline;
  }
`;

const BreadCrumbsWrapper = styled.div`
  padding: 24px 24px 0;
  position: relative;
  z-index: ${zIndex.BreadCrumb};
`;

CustomBreadCrumbs.Wrapper = BreadCrumbsWrapper;
